import React from "react";
import {Container, Row, Col, Card, Image, Button} from "react-bootstrap";
import {FaBuilding, FaSignOutAlt} from "react-icons/fa";
import clientsData from "../data/clients.json";
import userInfo from "../data/user.json";

const ClientSelector = ({onClientSelect, onLogout}) => {
  // En una aplicación real, los clientes vendrían asociados al usuario.
  // Por ahora, usamos todos los clientes del JSON.
  const userClients = clientsData;

  return (
    <>
      <style jsx>{`
        .client-card {
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
          cursor: pointer;
          min-height: 180px; /* Altura mínima para estandarizar las tarjetas */
          width: 100%; /* Asegura que la tarjeta ocupe toda la columna */
        }
        .client-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        .client-logo {
          max-height: 60px;
          max-width: 150px;
          width: auto; /* Asegura que el logo no se estire si es pequeño */
          object-fit: contain;
        }
      `}</style>
      <Container
        fluid
        className="d-flex align-items-center justify-content-center bg-light"
        style={{minHeight: "100vh"}}
      >
        <div className="w-100">
          <div className="position-absolute top-0 end-0 p-4">
            <Button variant="outline-secondary" size="sm" onClick={onLogout}>
              <FaSignOutAlt className="me-2" />
              Cerrar Sesión
            </Button>
          </div>

          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={7}>
              <div className="text-center mb-5">
                <h2 className="fw-bold">
                  Bienvenido, {userInfo.name.split(" ")[0]}
                </h2>
                <p className="text-muted fs-5">
                  Selecciona un cliente para continuar
                </p>
              </div>

              <Row className="g-4 justify-content-center">
                {userClients.map((client) => (
                  <Col xs={12} sm={6} md={4} lg={4} xl={2} key={client.id}>
                    <Card
                      className="client-card shadow-sm rounded-4 border-0 h-100"
                      onClick={() => onClientSelect(client)}
                    >
                      <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center p-4">
                        <Image
                          src={client.logo}
                          alt={`${client.name} logo`}
                          className="client-logo mb-4"
                        />
                        <h5 className="fw-bold mb-0">{client.name}</h5>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <div className="text-center mt-5">
            <small className="text-muted">
              <FaBuilding className="me-1" />
              PorterCom Platform &copy; {new Date().getFullYear()}
            </small>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ClientSelector;
